<template>
  <div class="row">
    <div class="col-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em> {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="isCreate() || isUpdate()"
          @on-complete="storeUpdate"
          @showHideLoading="showHideLoading"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.confirm')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="validateFirstStep"
          >
            <first-step ref="firstStep" @on-validated="onValidated" />
          </tab-content>
          <tab-content :title="$t('common_words.details')">
            <step-confirm :infoData="model" />
          </tab-content>
        </form-wizard>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import StepConfirm from './steps/StepConfirm.vue';

export default {
  components: { FirstStep, StepConfirm },
  mixins: [MixinAlert, MixinLoading, MixinMenu, MixinPermissions],
  data() {
    return { model: { names: [], codes: [], ids: [] } };
  },
  methods: {
    validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    onValidated(model) {
      this.model = { ...model };
    },
    storeUpdate() {
      this.showHideLoading(true);
      this.model.route = 'irrigation/valves';
      const editForm = sessionStorage.getItem('editForm');
      const request =
        editForm && this.isUpdate() ? Axios.updateMaster : Axios.saveMaster;
      if (editForm) this.model.id = JSON.parse(editForm).id;
      request(this.model)
        .then((response) => {
          this.showHideLoading();
          showContinue(
            this,
            response.data.message || response.errors,
            '/irrigation/valves',
            null
          );
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },
  mounted() {
    this.selectedItemOnMenu('irrigation/valves');
    this.showHideLoading(true);
    setTimeout(() => {
      this.showHideLoading();
    }, 3000);
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('irrigation/valves');
  },
};
</script>
